import {Component} from '@angular/core'
import {FormsModule, ReactiveFormsModule} from '@angular/forms'
import {MatError, MatFormField, MatLabel, MatSuffix} from '@angular/material/form-field'
import {MatIcon} from '@angular/material/icon'
import {MatInput} from '@angular/material/input'
import {FormatNumberDirective} from '@sparbanken-syd/sparbanken-syd-theme'
import {BaseComponent} from '../base.component'

// import fr
@Component({
  selector: 'spb-gross-salary',
  imports: [
    MatFormField,
    MatInput,
    MatLabel,
    ReactiveFormsModule,
    FormsModule,
    MatSuffix,
    MatError,
    MatIcon,
    FormatNumberDirective
  ],
  templateUrl: './gross-salary.component.html',
  providers: [{provide: BaseComponent, useExisting: GrossSalaryComponent}]
})
export class GrossSalaryComponent extends BaseComponent {
  public override debugName = 'gross-salary'
}
